export const UNIT_ALERT = {
  PROMPT_FOR_UNIT: 'promptForUnit',
  VALIDATED_WITHOUT_UNIT: 'validatedWithoutUnit',
} as const;

export type UnitAlertValue = (typeof UNIT_ALERT)[keyof typeof UNIT_ALERT];

export const NUMBER_OF_UNITS_ERROR = 'Number of units must be a whole number';
export const POSITIVE_NUMBER_OF_UNITS_ERROR = 'Number of units must be greater than 0';
export const MAX_NUM_UNITS_VALUE = 20000;
export const MAX_NUM_UNITS_ERROR = `Number of units must be less than or equal to ${MAX_NUM_UNITS_VALUE}`;
export const MAX_NUM_MULTIPLEX_UNITS_VALUE = 24;
export const MAX_NUM_MULTIPLEX_UNITS_ERROR = `Number of units must be less than or equal to ${MAX_NUM_MULTIPLEX_UNITS_VALUE}`;
